// // import React from "react";
// // import { FaBookOpen, FaTheaterMasks, FaWindowMaximize } from "react-icons/fa";

// // const featuresData = [
// //   {
// //     icon: FaBookOpen,
// //     title: "AI Agents & Automation Platforms",
// //     description:
// //       "We develop AI-powered agents and automation systems that streamline operations, enhance customer support, and optimize business workflows.",
// //   },
// //   {
// //     icon: FaTheaterMasks,
// //     title: "Blockchain & Smart Contract Development",
// //     description:
// //       "Secure blockchain solutions and smart contracts that automate transactions, ensure transparency, and power decentralized applications.",
// //   },
// //   {
// //     icon: FaWindowMaximize,
// //     title: "Crypto Exchange & Token Development",
// //     description:
// //       "End-to-end crypto solutions including centralized exchanges, token creation, trading engines, wallet systems, and liquidity integrations.",
// //   },
// //   {
// //     icon: FaBookOpen,
// //     title: "Web3, DeFi & NFT Ecosystems",
// //     description:
// //       "Build decentralized platforms including DeFi protocols, NFT marketplaces, tokenized assets, and Web3-enabled applications.",
// //   },
// //   {
// //     icon: FaTheaterMasks,
// //     title: "Custom CRM, ERP & HRM Systems",
// //     description:
// //       "Tailored enterprise software to manage sales, operations, HR, inventory, and analytics with scalable and integrated dashboards.",
// //   },
// //   {
// //     icon: FaWindowMaximize,
// //     title: "Mobile & Web Application Development",
// //     description:
// //       "Modern mobile and web apps designed for performance, security, and scalability, delivering seamless user experiences across devices.",
// //   },
// // ];

// // function Features() {
// //   return (
// //     <div className="services-style-five-area default-padding bottom-less">
// //       <div className="container">
// //         <div className="left-heading">
// //           <div className="row">
// //             <div className="col-lg-8 offset-lg-2">
// //               <h4 className="sub-title">Service Blocks</h4>
// //               <div className="right">
// //                 <h2 className="title split-lines">
// //                   Services That Make Xeer Technology Unique
// //                 </h2>
// //                 <p>
// //                   Artificial Intelligence refers to the development of computer systems
// //                   that can perform tasks that would typically require human intelligence.
// //                   It involves the creation of algorithms and models that enable machines
// //                   to learn, reason, and perceive most necessitating option intelligence
// //                   for your resources.
// //                 </p>
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       </div>

// //       <div className="container">
// //         <div className="services-style-five-items">
// //           <div className="row">
// //             {featuresData.map((feature, idx) => {
// //               const Icon = feature.icon;
// //               return (
// //                 <div
// //                   key={idx}
// //                   className="col-xl-4 col-lg-6 col-md-6 mb-30 service-five-single"
// //                 >
// //                   <div className="service-style-five-item">
// //                     <Icon style={{ fontSize: "36px", color: "#2f6edb", marginBottom: "12px" }} />
// //                     <h4>{feature.title}</h4>
// //                     <p>{feature.description}</p>
// //                   </div>
// //                 </div>
// //               );
// //             })}
// //           </div>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // }

// // export default Features;

// import React from "react";
// import {
//   FaRobot,
//   FaLink,
//   FaCoins,
//   FaCube,
//   FaUsersCog,
//   FaMobileAlt,
// } from "react-icons/fa";

// const featuresData = [
//   {
//     icon: FaRobot,
//     title: "AI Agents & Automation Platforms",
//     description:
//       "We develop AI-powered agents and automation systems that streamline operations, enhance customer support, and optimize business workflows.",
//   },
//   {
//     icon: FaLink,
//     title: "Blockchain & Smart Contract Development",
//     description:
//       "Secure blockchain solutions and smart contracts that automate transactions, ensure transparency, and power decentralized applications.",
//   },
//   {
//     icon: FaCoins,
//     title: "Crypto Exchange & Token Development",
//     description:
//       "End-to-end crypto solutions including centralized exchanges, token creation, trading engines, wallet systems, and liquidity integrations.",
//   },
//   {
//     icon: FaCube,
//     title: "Web3, DeFi & NFT Ecosystems",
//     description:
//       "Build decentralized platforms including DeFi protocols, NFT marketplaces, tokenized assets, and Web3-enabled applications.",
//   },
//   {
//     icon: FaUsersCog,
//     title: "Custom CRM, ERP & HRM Systems",
//     description:
//       "Tailored enterprise software to manage sales, operations, HR, inventory, and analytics with scalable and integrated dashboards.",
//   },
//   {
//     icon: FaMobileAlt,
//     title: "Mobile & Web Application Development",
//     description:
//       "Modern mobile and web apps designed for performance, security, and scalability, delivering seamless user experiences across devices.",
//   },
// ];

// function Features() {
//   return (
//     <div className="services-style-five-area default-padding bottom-less">
//       <div className="container">
//         <div className="left-heading">
//           <div className="row">
//             <div className="col-lg-8 offset-lg-2">
//               <h4 className="sub-title">Service Blocks</h4>
//               <div className="right">
//                 <h2 className="title split-lines">
//                   Services That Make Xeer Technology Unique
//                 </h2>
//                 <p>
//                   We deliver high-performance digital solutions combining AI,
//                   Blockchain, and modern software systems — built to scale,
//                   secure, and drive real business growth.
//                 </p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div className="container">
//         <div className="services-style-five-items">
//           <div className="row">
//             {featuresData.map((feature, idx) => {
//               const Icon = feature.icon;
//               return (
//                 <div
//                   key={idx}
//                   className="col-xl-4 col-lg-6 col-md-6 mb-30 service-five-single"
//                 >
//                   <div className="service-style-five-item">
//                     <Icon
//                       style={{
//                         fontSize: "36px",
//                         color: "#2f6edb",
//                         marginBottom: "12px",
//                       }}
//                     />
//                     <h4>{feature.title}</h4>
//                     <p>{feature.description}</p> {/* FULL TEXT */}
//                   </div>
//                 </div>
//               );
//             })}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Features;

import React from "react";
import {
  FaRobot,
  FaLink,
  FaCoins,
  FaCube,
  FaUsersCog,
  FaMobileAlt,
  FaCheckCircle,
} from "react-icons/fa";

const features = [
  {
    icon: FaRobot,
    title: "AI Agents & Automation Platforms",
    desc: "Build intelligent systems that automate workflows, enhance customer experience, and improve operational efficiency.",
    points: [
      "AI Agents & Chatbots",
      "Workflow Automation",
      "Business Process Optimization",
    ],
  },
  {
    icon: FaLink,
    title: "Blockchain & Smart Contract Development",
    desc: "Secure and scalable blockchain solutions designed for transparency, automation, and decentralized ecosystems.",
    points: [
      "Smart Contracts",
      "DeFi Platforms",
      "Enterprise Blockchain Systems",
    ],
  },
  {
    icon: FaCoins,
    title: "Crypto Exchange & Token Development",
    desc: "End-to-end crypto infrastructure built for performance, security, and scalability.",
    points: [
      "Centralized & Decentralized Exchanges",
      "Token Development",
      "Wallet & Liquidity Integration",
    ],
  },
  {
    icon: FaCube,
    title: "Web3, DeFi & NFT Ecosystems",
    desc: "Build next-generation decentralized platforms with real-world usability and scalability.",
    points: ["DeFi Protocols", "NFT Marketplaces", "Tokenized Assets"],
  },
  {
    icon: FaUsersCog,
    title: "Custom CRM, ERP & HRM Systems",
    desc: "Streamline operations with tailored enterprise solutions designed for efficiency and growth.",
    points: [
      "CRM & ERP Platforms",
      "HRM & Workflow Systems",
      "Business Automation Tools",
    ],
  },
  {
    icon: FaMobileAlt,
    title: "Mobile & Web Application Development",
    desc: "High-performance applications built for scalability, security, and seamless user experience.",
    points: ["iOS & Android Apps", "Web Applications", "SaaS Platforms"],
  },
];

function Features() {
  return (
    <section className="xeer-features">
      <div className="container">
        {/* HEADER */}
        <div className="text-center pb-5">
          {/* <h5> Our Expertise</h5> */}
          <h2 className="title text-white split-lines">
            Scalable Digital Solutions That Drive Growth
          </h2>
          <p className="text-white">
            We deliver high-performance digital solutions combining AI,
            Blockchain, and modern software systems — built to scale, secure,
            and drive real business growth.
          </p>
        </div>

        {/* GRID */}
        <div className="row">
          {features.map((item, i) => {
            const Icon = item.icon;
            return (
              <div key={i} className="col-lg-4 col-md-6 mb-4">
                <div className="feature-card">
                  <div className="icon-box">
                    <Icon />
                  </div>

                  <h4>{item.title}</h4>
                  <p className="desc">{item.desc}</p>

                  <ul>
                    {item.points.map((p, idx) => (
                      <li key={idx}>
                        <FaCheckCircle size={14} />
                        <span>{p}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            );
          })}
        </div>

        {/* 🔥 FIXED CLOSING SECTION */}
        <div className="closing-wrapper">
          <p>
            We don’t just build software — we build scalable digital products
            that power long-term business growth.
          </p>
        </div>
      </div>
    </section>
  );
}

export default Features;
